import { render, staticRenderFns } from "./DragItem.vue?vue&type=template&id=48ffd008&scoped=true&"
import script from "./DragItem.vue?vue&type=script&lang=ts&"
export * from "./DragItem.vue?vue&type=script&lang=ts&"
import style0 from "./DragItem.vue?vue&type=style&index=0&id=48ffd008&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ffd008",
  null
  
)

export default component.exports